import {mapState, mapGetters, mapActions, mapMutations} from 'vuex'
import Loading from '@/components/Core/Loading'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import ApiManager from "@/utils/ApiManager";

export default {
    name: 'Partner',
    components: {
        Loading
    },
    metaInfo() {
        let title = this.categoryName + ' | ' + Constants.SiteInfo.title
        this.setMeta({title: title})
        return this.getMeta
    },
    data() {
        return {
            loading: true,
            registerHash: Constants.RegisterHash,

            // テーブルオプション
            tableColumns: [
                'partnerId',
                'partnerName',
                'serviceName',
                'communityName',
                'tenantName',
                'registeredAt',
                'status',
                'detailButton'
                // 'deleteButton'
            ],
            tableData: [],
            tableOptions: {
                headings: {
                    partnerId: '外部連携システムID',
                    partnerName: '外部連携システム名',
                    serviceName: 'サービス名',
                    communityName: 'コミュニティ名',
                    tenantName: 'テナント名',
                    registeredAt: '登録年月日',
                    status: 'ステータス',
                    detailButton: ''
                    // deleteButton: ''
                },
                columnsClasses: {
                    partnerId: 'wp-5',
                    partnerName: '',
                    serviceName: '',
                    communityName: '',
                    tenantName: '',
                    registeredAt: '',
                    status: '',
                    detailButton: 'wp-5 has-button'
                    // deleteButton: 'wp-5 has-button'
                },
                sortable: [
                    'partnerId',
                    'partnerName',
                    'serviceName',
                    'communityName',
                    'tenantName',
                    'registeredAt',
                    'status'
                ],
                filterable: [],
                texts: Constants.TableOptions.getTexts(this.categoryName),
                perPage: Constants.TablePerPageInitial,
                perPageValues: Constants.TableOptions.perPageValues,
                pagination: Constants.TableOptions.pagination
            },

            // 絞込み
            activeFilters: false,
            filterPerPage: Constants.TablePerPageInitial,

            deleteTargetId: null
        }
    },
    mounted() {
        this.$set(this.tableOptions, 'texts', Constants.TableOptions.getTexts(this.categoryName))

        this.init()
    },
    beforeDestroy() {
        if (this.$route.name !== 'Partner') {
            this.reset()
        }
    },
    computed: {
        ...mapState({
            categoryName: state => state.partner.categoryName,

            // model
            partnerModel: state => state.partner.partnerModel,
            serviceModel: state => state.partner.serviceModel,
            tenantModel: state => state.partner.tenantModel,
            communityModel: state => state.partner.communityModel,

            // 検索
            filters: state => state.partner.filters,

            // confirm
            confirmKey: state => state.confirm.key,
            confirmAccepted: state => state.confirm.accept
        }),
        ...mapGetters({
            getMeta: 'meta/get',
            permittedView: 'permission/permittedView',
            isSmartPhone: 'core/isSmartPhone'
        }),

        // search
        serviceList() {
            return this.serviceModel
                .filter(item => item.serviceStatus === 1)
                .map(item => {
                    return {
                        value: item.serviceUuid,
                        label: item.serviceName
                    }
                })
        },
        statusList() {
            return Constants.Status.sort(Utility.sortByKey('index', true))
        },
        tenantList() {
            return this.tenantModel.map(item => {
                return {
                    value: item.tenant.tenantUuid,
                    label: item.tenant.name
                }
            })
        },
        communityList() {
            return this.communityModel.map(item => {
                return {
                    value: item.communityUuid,
                    label: item.name
                }
            })
        },

        // list
        tablePerPageList() {
            let list = []
            Constants.TablePerPage.forEach(item => list.push({
                value: item,
                label: item
            }))
            return list
        },
        showFilters() {
            return !this.isSmartPhone ||
                this.activeFilters
        },

        // filter
        searchPartnerName: {
            get() {
                return this.filters.name
            },
            set(value) {
                this.setInputFilter({
                    key: 'name',
                    value: value
                })
            }
        },
        searchEmail: {
            get() {
                return this.filters.email
            },
            set(value) {
                this.setInputFilter({
                    key: 'email',
                    value: value
                })
            }
        },
        searchService: {
            get() {
                return this.filters.serviceUuid
            },
            set(value) {
                this.setInputFilter({
                    key: 'serviceUuid',
                    value: value
                })
            }
        },
        searchStatus: {
            get() {
                return this.filters.status
            },
            set(value) {
                this.setInputFilter({
                    key: 'status',
                    value: value
                })
            }
        },
        searchTenant: {
            get() {
                return this.filters.tenantUuid
            },
            set(value) {
                this.setInputFilter({
                    key: 'tenantUuid',
                    value: value
                })
            }
        },
        searchCommunity: {
            get() {
                return this.filters.communityUuid
            },
            set(value) {
                this.setInputFilter({
                    key: 'communityUuid',
                    value: value
                })
            }
        },
    },
    watch: {
        confirmAccepted: function (to) {
            console.log('confirmKey : ', this.confirmKey, to)
            // 削除
            if (this.confirmKey === 'delete' && to) {
                this.deleteData()
            }
        }
    },
    methods: {
        ...mapActions({
            setMeta: 'meta/set',
            showError: 'error/show',
            loadModel: 'partner/loadModel',
            loadPartnerList: 'partner/loadPartnerList',
            reset: 'partner/reset',
            showConfirm: 'confirm/show',
            showToast: 'toast/show',
        }),
        ...mapMutations({
            setInputFilter: 'partner/setInputFilter',
        }),

        init() {
            this.loading = true

            //
            let partnerParams = {filters: {}}
            if (this.searchPartnerName)
                partnerParams.filters.name = this.searchPartnerName
            if (this.searchEmail)
                partnerParams.filters.email = this.searchEmail
            if (this.searchService !== '')
                partnerParams.filters.serviceUuid = this.searchService
            if (this.searchStatus !== '')
                partnerParams.filters.status = this.searchStatus
            if (this.searchTenant !== '')
                partnerParams.filters.tenantUuid = this.searchTenant
            if (this.searchCommunity !== '')
                partnerParams.filters.communityUuid = this.searchCommunity
            let serviceDetailParams = {
                serviceUuid: this.userServiceUuid
            }
            console.log('search.parameters', partnerParams, serviceDetailParams)

            // データ読出し
            this.loadModel({
                partnerParams: partnerParams,
                serviceDetailParams: serviceDetailParams
            })
                // eslint-disable-next-line
                .then(res => {
                    this.loading = false
                    this.tableData = $.extend(true, [], this.partnerModel)
                })
                .catch(error => {
                    this.showError(error || null)
                })
        },
        getViewData(props) {
            let key = props.column
            let value = props.row[key]
            console.log('getViewData', key, value)
            switch (key) {
                case 'status':
                    return Utility.getConstantsLabel(['Status'], value)
            }
            return value
        },
        changePage() {
            // console.log(this.$refs.table.page)
        },

        // 検索
        resetSearch() {
            this.searchPartnerName = null
            this.searchEmail = null
            this.searchService = ''
            this.searchStatus = ''
            this.searchTenant = ''
            this.searchCommunity = ''

            this.init()
        },
        search() {
            this.loading = true

            //
            let partnerParams = {filters: {}}
            if (this.searchPartnerName)
                partnerParams.filters.name = this.searchPartnerName
            if (this.searchEmail)
                partnerParams.filters.email = this.searchEmail
            if (this.searchService !== '')
                partnerParams.filters.serviceUuid = this.searchService
            if (this.searchStatus !== '')
                partnerParams.filters.status = this.searchStatus
            if (this.searchTenant !== '')
                partnerParams.filters.tenantUuid = this.searchTenant
            if (this.searchCommunity !== '')
                partnerParams.filters.communityUuid = this.searchCommunity
            console.log('search.parameters', partnerParams)

            // データ読出し
            this.loadPartnerList({
                partnerParams: partnerParams
            })
                .then(res => {
                    this.loading = false
                    this.tableData = $.extend(true, [], this.partnerModel)
                })
                .catch(error => {
                    this.showError(error || null)
                })
        },

        // 絞り込み
        toggleFilters() {
            this.activeFilters = !this.activeFilters
        },
        changePerPage() {
            this.$refs.table.setLimit(this.filterPerPage)
        },

        detailItem(props) {
            this.$router.push({
                name: 'PartnerForm',
                params: {
                    partnerId: String(props.row.partnerUuid)
                }
            })
        },

        /*
        deleteItem(props) {
            this.deleteTargetId = props.row.partnerUuid
            this.showConfirm({
                key: 'delete',
                title: '',
                body: '「外部連携システム名 : ' + props.row.partnerName + '」の' + this.categoryName + 'を削除しますか？',
                acceptLabel: '削除'
            })
        },

        deleteData() {
            let parameters = {
                partnerUuid: this.deleteTargetId
            }
            console.log('delete data', parameters)

            ApiManager.request(
                ['partner'],
                ['v1PartnerDelete'],
                [parameters])
                .then(res => {
                    let status = Utility.parseResponse(res)
                    if (status.result) {
                        this.showToast({
                            title: this.categoryName + 'の削除',
                            body: '指定' + this.categoryName + 'を削除しました。'
                        })
                        this.deleteTargetId = null
                        // 一覧データを再読出し
                        this.init()
                    } else if (status.error) {
                        // エラーメッセージ表示
                        this.showError(res)
                    } else {
                        // アプリケーションエラー表示
                        this.showError(null)
                    }

                })
                // eslint-disable-next-line
                .catch(error => {
                    this.showError(null)
                })
        }
        */
    }
}